'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.i18nReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18n = require('../constants/i18n');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    defaultLanguageKey: 'en',
    languageKey: null,
    languageList: {},
    messages: {}
};

var i18nReducer = function i18nReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _i18n.ACTION_TYPES.SET_LANGUAGE_KEY:
            return _extends({}, state, {
                languageKey: action.payload
            });
        case _i18n.ACTION_TYPES.SET_LANGUAGE_LIST:
            return _extends({}, state, {
                languageList: action.payload
            });
        case _i18n.ACTION_TYPES.SET_TRANSLATION_LIST:
            return _extends({}, state, {
                messages: _extends({}, state.messages, _defineProperty({}, action.payload.languageKey, action.payload.translationList))
            });
        case _i18n.ACTION_TYPES.UPDATE_TRANSLATION_LIST:
            return _extends({}, state, {
                messages: _extends({}, state.messages, _defineProperty({}, action.payload.languageKey, _extends({}, state.messages[action.payload.languageKey], action.payload.translationList)))
            });
        default:
            return state;
    }
};

exports.i18nReducer = i18nReducer;